export const Pattern = {
	Integer: /^-?\d+$/,
	Decimal: /^-?\d+(?:\.\d+)?$/,
	DecimalWithCommaOrDotSeparator: /^-?\d+(?:[.,]\d+)?$/,
	DecimalWithThousandsSeparator: /^-?\d+(?:,\d\d\d)*?(?:\.\d+)?$/,
	Email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
}
